'use client';

import { defaultLocale, locales, type Locale } from '@/lib/i18n/dictionaries';
import { useParams } from 'next/navigation';

const normalizeLocale = (value?: string | string[]): Locale => {
  const locale =
    typeof value === 'string' ? value : Array.isArray(value) ? value[0] : null;
  return locales.includes(locale as Locale)
    ? (locale as Locale)
    : defaultLocale;
};

export const useLocalePath = () => {
  const params = useParams<{ locale?: string | string[] }>();
  const locale = normalizeLocale(params?.locale);
  const prefix = `/${locale}`;

  const to = (path: string) => {
    const normalized = path.startsWith('/') ? path : `/${path}`;
    if (normalized === '/') return prefix;
    if (normalized === prefix || normalized.startsWith(`${prefix}/`)) {
      return normalized;
    }
    return `${prefix}${normalized}`;
  };

  return { locale, prefix, to };
};
